import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
    computed: {
        ...mapState('product', ['productList']),

        productLoading() {
            return this.onLoading('fetch-product');
        },
    },

    methods: {
        ...mapActions('product', [
            'findProducts',
            'getProduct',
            'getProductListIfNecessary',
        ]),

        getDefaultVariant(variants) {
            if (variants.length === 1) {
                let v = variants.find(v => v.default);

                if (!_.isNil(v)) return v.name;
            }

            return 'All variants';
        },

        refreshProductList: _.debounce(function(query) {
            this.getProductListIfNecessary({ query: query, relation: true });
        }, 500),

        productImg(product) {
            return product.media_urls.length
                ? _.last(product.media_urls).s512
                : '/img/slurp-500.png';
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/products.js